import React, { useCallback, useState } from 'react';
import { makeStyles } from "../../styles/index";
import { MonthPickerField } from "./fields/MonthPickerField";
var useStyles = makeStyles(function () { return ({
    root: {
        display: 'flex',
    },
    month: {
        flex: '1 0 0',
        minWidth: 0,
    },
}); }, { name: 'SnMonthPicker' });
/**
 * 年月選択コンポーネント。
 */
export var MonthPicker = function (props) {
    var className = props.className, style = props.style, value = props.value, _a = props.disableFuture, disableFuture = _a === void 0 ? false : _a, _b = props.disablePast, disablePast = _b === void 0 ? false : _b, clearable = props.clearable, onChange = props.onChange;
    var _c = useState(null), localValue = _c[0], setLocalValue = _c[1];
    var currentValue = value !== undefined ? value : localValue;
    var handleChange = useCallback(function (month) {
        var _a;
        var nextValue = (_a = month === null || month === void 0 ? void 0 : month.startOf('month')) !== null && _a !== void 0 ? _a : null;
        setLocalValue(nextValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }, [onChange]);
    var classes = useStyles(props);
    return (React.createElement(MonthPickerField, { className: className, classes: classes, style: style, value: currentValue, disableFuture: disableFuture, disablePast: disablePast, clearable: clearable, onChange: handleChange }));
};
